import React from 'react';
import { useQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { Country } from '@trnsact/trnsact-shared-types';

import { DealSheetRulesFilters } from './index';
import { dealSheetConfigurationApi } from '../../../../api';

export const Province = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  const { data: canadaRegionsResponse, loading: canadaRegionsLoading } = useQuery(
    dealSheetConfigurationApi.getRegions,
    {
      variables: { input: { country: Country.Ca } },
    }
  );

  const canadaRegions = canadaRegionsResponse?.dealSheets?.result?.list ?? [];

  return (
    <AutocompleteField
      multiple
      size="small"
      name="PROVINCE"
      control={control}
      disableCloseOnSelect
      options={canadaRegions}
      loading={canadaRegionsLoading}
      textFieldProps={{ variant: 'outlined', label: 'Province' }}
    />
  );
};
